import React from 'react';
import styled from 'styled-components';
import { FaShieldAlt, FaBolt, FaHeadset } from 'react-icons/fa';

// --- Estilos ---
const InfoBoxes = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin: 40px 0;
  max-width: 1200px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const InfoBox = styled.div`
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  display: flex;
  align-items: flex-start;
  gap: 15px;
  
  .icon { // Usando uma classe para o ícone
    color: ${({ theme }) => theme.colors.primary};
    font-size: 24px;
    margin-top: 3px;
    width: 25px;
    text-align: center;
  }
`;

// --- Componente ---
const PaymentSupport = () => (
  <InfoBoxes>
    <InfoBox>
      <div className="icon"><FaShieldAlt /></div>
      <div>
        <h4>Pagamento Seguro</h4>
        <p>Utilizamos tecnologia de criptografia para proteger sua transação.</p>
      </div>
    </InfoBox>
    <InfoBox>
      <div className="icon"><FaBolt /></div>
      <div>
        <h4>Entrega Imediata</h4>
        <p>Relatório liberado instantaneamente após confirmação do pagamento.</p>
      </div>
    </InfoBox>
    <InfoBox>
      <div className="icon"><FaHeadset /></div>
      <div>
        <h4>Suporte 24/7</h4>
        <p>Problemas com o pagamento? Nossa equipe está pronta para ajudar.</p>
      </div>
    </InfoBox>
  </InfoBoxes>
);

export default PaymentSupport;